import {
  r
} from "./chunk.4JTBA2KG.js";

// src/styles/breakpoint.styles.ts
function xs(styling) {
  return r` @media (max-width: 575px) { ${styling} } `;
}
function smUp(styling) {
  return r` @media (min-width: 576px) { ${styling} } `;
}
function mdUp(styling) {
  return r` @media (min-width: 768px) { ${styling} } `;
}
function lgUp(styling) {
  return r` @media (min-width: 992px) { ${styling} } `;
}
function xlUp(styling) {
  return r` @media (min-width: 1200px) { ${styling} } `;
}
function xxl(styling) {
  return r` @media (min-width: 1400px) { ${styling} } `;
}

export {
  xs,
  smUp,
  mdUp,
  lgUp,
  xlUp,
  xxl
};
